import * as THREE from 'three';

/** Which way a knocked-down body lies when it starts to get up: on its back (it fell backward) or on its front (it fell forward). */
export type GetUpFace = 'up' | 'down';
/** What a body's animator is asked to show while it gets up from Prone (see `unit-death.ts`): how far through the stand-up it is (0 to 1). */
export interface GetUp {
  progress: number; face: GetUpFace;
  /** Where the hands and feet lay (wrists and ankles, root frame): the limbs reach from there to the clip's, so they do not sweep through the ground. */
  from?: GetUpFrom;
}
/**
 * How the body lay when it began to get up, in the root frame turned to match the clip: the pelvis (position and rotation), the local rotations of
 * the spine, ribcage, neck and head, and the wrists and ankles. The clip starts from here and reaches its own pose as the ragdoll hands over.
 */
export interface GetUpFrom {
  hips: THREE.Vector3; pelvis: THREE.Quaternion; spine?: THREE.Quaternion; chest: THREE.Quaternion; neck?: THREE.Quaternion; head: THREE.Quaternion;
  hands: [THREE.Vector3, THREE.Vector3]; feet: [THREE.Vector3, THREE.Vector3];
  /** Which way each elbow and knee pointed (root frame), or undefined for a limb lying straight. */
  elbows: [THREE.Vector3?, THREE.Vector3?]; knees: [THREE.Vector3?, THREE.Vector3?];
}
/**
 * How the root turns from the way the body lay to the way the unit faces (0 lying, 1 facing): the figure turns as it comes up off the knee.
 * Shared so the controller and the bodies agree on it.
 */
export function getUpTurn(progress: number) { return THREE.MathUtils.smoothstep(progress, .45, .85); }

/** How much of the get-up replaces the body's own standing pose: all of it until the figure is up, then it hands back. */
export function getUpHold(progress: number) { return 1 - THREE.MathUtils.smoothstep(progress, .86, 1); }
/** How far the body has come from the way it lay to the clip's own pose (the trunk, and the hands and feet). */
export function getUpReach(progress: number) { return THREE.MathUtils.smoothstep(progress, 0, .3); }
